import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, MustMatch, UserService } from 'lib-trend-core';
import { timer } from 'rxjs';

@Component({
    // templateUrl: 'update-password.component.html',
    templateUrl: 'update-password.v2.component.html',
    styleUrls: ['update-password.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpdatePasswordComponent extends AbstractComponent implements OnInit {

  hideAllPasswords: boolean = true;
  userId: string;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<UpdatePasswordComponent>,
    
    private userService : UserService
  ) {
    super(injector);
    this.setupForm();
  }

  ngOnInit() {
    this.getUserId();
  }

  setupForm(): void {
    this.formGroup = this.formBuilder.group({
      currentPassword: ['', [Validators.required, Validators.minLength(6)]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmedPassword: ['', [Validators.required, Validators.minLength(6)]],
    }, { validators: [MustMatch('newPassword', 'confirmedPassword')] });
  }

  getUserId(): void {
    this.userId = this.getIDCurrentUser();
    if (!this.userId) {
      this.alertService.error(this.t('updatePassword.home.userNotLoggedError'));
    }
  }

  save(): void {
    if (this.formGroup.invalid) {
      return;
    }

    this.loading = true;
    const currentPassword = this.formGroup.get('currentPassword').value;
    const newPassword = this.formGroup.get('newPassword').value;
    const confirmedNewPassword = this.formGroup.get('confirmedPassword').value;

    this.userService.updatePassword(super.getIDCurrentUser(),{newPassword, confirmedNewPassword, currentPassword} ).subscribe({
      next: () => {
        this.alertService.success(this.t('updatePassword.home.passwordUpdatedSuccess'));
        timer(5000).subscribe(() => {
          this.loading = false;
          window.location.href = '/';
        });
      },
      error: err => {
        this.alertService.error(err.error.message || this.t('updatePassword.home.passwordUpdateError'));
        this.loading = false;
      }
    });
  }

  togglePasswordVisibility(): void {
    this.hideAllPasswords = !this.hideAllPasswords;
  }

  close(): void {
    this.dialogRef.close();
  }
}
